import { LogEntry, LogFields } from '@app/types/interfaces';
import { createContext } from 'react';

export interface LoggerContext {
    logs: LogEntry[];
    logInfo: (message: string, options?: { event?: string; fields?: LogFields }) => void;
    logWarn: (message: string, options?: { event?: string; fields?: LogFields }) => void;
    logError: (message: string, options?: { event?: string; fields?: LogFields }) => void;
    traceId: string;
}

export const LoggerContext = createContext<LoggerContext | null>(null);
